import { useMutation } from "@tanstack/react-query";
import { getServiceManagementRedirectUrl } from "../services/sso-service";

export const useServiceManagementSso = () => {
  return useMutation({
    mutationFn: (companyId: number) =>
      getServiceManagementRedirectUrl(companyId),
  });
};
